module.exports = __webpack_public_path__ + "static/media/chevron.21b77383.svg";